import { trackEvent } from 'lib/utils/analytics'
import { FunctionComponent } from 'react'
import Image from '../Image'
import Link from '../Link'
import Card from './Card'

interface IProjectCardProps {
  title: string
  description: string
  imgSrc: string
  href: string
}

const ProjectCard: FunctionComponent<IProjectCardProps> = ({
  title,
  description,
  imgSrc,
  href,
}) => {
  const trackProjectClick = () => {
    trackEvent({ name: 'Project Link Clicked', data: { link: href } })
  }

  return (
    <Card>
      <Link
        href={href}
        aria-label={`Link to ${title}`}
        showExternalIcon={false}
        showExternalPreview={false}
        onClick={trackProjectClick}
      >
        <div
          className="flex-1 bg-gray-100 dark:bg-gray-900 rounded-md flex flex-col justify-center h-full group"
          key={title}
          aria-label={`Learn more about "${title}"`}
        >
          <div className="h-full">
            <div>
              {imgSrc && (
                <Image
                  alt={title}
                  src={imgSrc}
                  className="object-cover object-center group-hover:scale-105 lg:h-48 md:h-36"
                  width={544}
                  height={306}
                />
              )}
            </div>
          </div>
          <div className="p-6">
            <div className="flex-1">
              <p className="text-2xl mt-3 font-semibold text-gray-900 dark:text-white">{title}</p>
              <p className="mt-4 text-base text-gray-500 dark:text-gray-300">{description}</p>
            </div>
            <div className="mt-6 flex items-center">
              <div className="text-sm text-gray-500 dark:text-gray-300 group-hover:text-primary-500 transition duration-300">
                Learn more &rarr;
              </div>
            </div>
          </div>
        </div>
      </Link>
    </Card>
  )
}

export default ProjectCard
